import { Component } from '@angular/core';
import { OnInit, OnDestroy } from "@angular/core";
import { Subscription } from 'rxjs';

import { MatDialogRef } from "@angular/material";
import { SnackbarService } from "../../../shared/services/snackbar.service";

import { SessionStorageService } from '../../../shared/services/session-storage.service';
import { DeleteService } from './delete.service';

@Component({
    selector: 'delete',
    template: require('./delete.component.html'),
    styles: [require('./delete.component.less')],
    providers: [DeleteService, SnackbarService],
    preserveWhitespaces: true
})

export class DeleteComponent implements OnInit, OnDestroy {
    requestData: any;
    allowTransferOnDelete: boolean = false;
    newlyAssignedUser: any;
    userDetails: any = [];
    paraAssignTo = {'margin': '2vw 0vw'};
    userSelectorClass: string = 'selector';
    isLoading: boolean;

    getUsersApiSubscription: Subscription;
    deleteApiSubscription: Subscription;

    constructor(
        private _sessionStorageService: SessionStorageService,
        private _deleteService:DeleteService,
        private dialogref:MatDialogRef<any>,
        private _mdlSnackbarService: SnackbarService
        ){
    }
    
    /**
     * set case study id
     * @param  {any} case_study_id contains case study id.
     */
    setrequestData(requestData: any){
        this.requestData = requestData;
        if (this.requestData.indexOf('user-delete') !== -1) {
            this.allowTransferOnDelete = true;
            this.requestData = this.requestData.replace('user-delete', '');
            let userId;
            this.paraAssignTo = {'margin': '2vw 0vw 0vw 0vw'};
            this._sessionStorageService.readItem('userDeleteId').then(data=> {
                userId = data;
                this.getUsersApiSubscription?.unsubscribe();
                this.getUsersApiSubscription = this._deleteService.getUserList(userId)
                    .subscribe((res: any) => this.userDetails = res.data
                        , error => {this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                            this.closeDialog()})
            });
        }
    }

    closeDialog(){
        this.dialogref.close();
    }

    // on delete button click
    onSubmit(){
        if (this.allowTransferOnDelete) {
            if(!this.newlyAssignedUser) {
                this.userSelectorClass = 'selector val-error';
                this._mdlSnackbarService.showSnackbar("FILL_REQUIRED_DETAILS", 'error');
            } else {
                this.deleteApiSubscription?.unsubscribe();
                this.isLoading = true;
                this.deleteApiSubscription = this._deleteService.delete(this.requestData, this.newlyAssignedUser).
                    subscribe((res: any) => this.deleteSuccessHandler(res),
                    error => this.deleteErrorHandler(error));
            }
        } else {
            this.isLoading = true;
            this.deleteApiSubscription?.unsubscribe();
            this.deleteApiSubscription = this._deleteService.delete(this.requestData).
                subscribe((res: any) => this.deleteSuccessHandler(res),
                error => this.deleteErrorHandler(error));
        }
    }

    // on delete success
    deleteSuccessHandler(res: any){
        this.isLoading = false;
        this._mdlSnackbarService.showSnackbar('DELETED', 'success');
        this.dialogref.close('deleted');
    }

    // on delete error
    deleteErrorHandler(error: any){
        this.isLoading = false;
        let errorMessage = 'SOMETHING_WENT_WRONG';
        if (error?.message === 'CS_UNFIT_DELETE') {
            errorMessage = 'CS_UNFIT_DELETE';
        }
        this._mdlSnackbarService.showSnackbar(errorMessage, 'error');
        this.dialogref.close('deleted');
    }

    ngOnInit(){
        this._sessionStorageService.readItem('deleteRequestData').then(data=> 
            this.setrequestData(data));
    }

    ngOnDestroy() {
        this.getUsersApiSubscription?.unsubscribe();
        this.deleteApiSubscription?.unsubscribe();
    }
}
